import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../../style/CommandPalette.scss';
import queries from '../../queries';
import { apolloClient } from '../../config';
import { touchRecent, toggleTheme } from '../../userPrefs';
import { t, locale, setLocale } from '../../i18n';

const STATIC_ITEMS = [
  { id: 'nav-projects', icon: 'folder-open', label: t('ui.pal.all'), hint: t('ui.pal.goto'), to: '/project' },
  { id: 'nav-new', icon: 'plus', label: t('ui.pal.new'), hint: t('ui.pal.action'), to: '/project/new' },
  { id: 'nav-displays', icon: 'desktop', label: t('ui.pal.displays'), hint: t('ui.pal.goto'), to: '/admin/displays' },
  { id: 'act-theme', icon: 'moon', label: t('ui.pal.theme'), hint: t('ui.pal.action'), action: () => toggleTheme() },
  { id: 'act-lang', icon: 'language', label: t('ui.pal.lang'), hint: t('ui.pal.action'), action: () => setLocale(locale === 'fr' ? 'en' : 'fr') },
  { id: 'nav-users', icon: 'users-cog', label: t('ui.pal.users'), hint: t('ui.pal.goto'), to: '/admin/users' },
];

class CommandPalette extends Component {

  state = { open: false, query: '', cursor: 0, projects: [] };

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('tsk-open-palette', this.open);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('tsk-open-palette', this.open);
  }

  onKeyDown = (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      this.state.open ? this.close() : this.open();
    } else if (e.key === 'Escape' && this.state.open) {
      this.close();
    }
  };

  open = () => {
    this.setState({ open: true, query: '', cursor: 0 });
    apolloClient
      .query({ query: queries.projects.list, fetchPolicy: 'cache-first' })
      .then(({ data }) => this.setState({ projects: (data && data.projects) || [] }))
      .catch(() => {});
  };

  close = () => this.setState({ open: false });

  items() {
    const q = this.state.query.trim().toLowerCase();
    const projects = this.state.projects.map((p) => ({
      id: p.id,
      icon: 'file-alt',
      label: p.name,
      hint: (p.devices || []).length ? t('ui.pal.iface_live') : t('ui.pal.iface'),
      to: `/project/${p.id}`,
      project: true,
    }));
    return [...STATIC_ITEMS, ...projects].filter((i) => !q || i.label.toLowerCase().includes(q)).slice(0, 12);
  }

  choose(item) {
    if (item.project) touchRecent(item.id);
    if (item.action) item.action();
    else this.props.history.push(item.to);
    this.close();
  }

  onInputKey = (e) => {
    const items = this.items();
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.setState(({ cursor }) => ({ cursor: Math.min(cursor + 1, items.length - 1) }));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.setState(({ cursor }) => ({ cursor: Math.max(cursor - 1, 0) }));
    } else if (e.key === 'Enter' && items[this.state.cursor]) {
      e.preventDefault();
      this.choose(items[this.state.cursor]);
    }
  };

  render() {
    const { open, query, cursor } = this.state;
    if (!open) return null;
    const items = this.items();
    return (
      <div className='tsk-palette-overlay' onMouseDown={this.close}>
        <div className='tsk-palette' role='dialog' aria-label={t('ui.nav.search')} onMouseDown={(e) => e.stopPropagation()}>
          <div className='tsk-palette__input'>
            <FontAwesomeIcon icon={['fas', 'search']} />
            <input
              autoFocus
              type='text'
              placeholder={t('ui.pal.placeholder')}
              value={query}
              onChange={(e) => this.setState({ query: e.target.value, cursor: 0 })}
              onKeyDown={this.onInputKey}
            />
            <kbd>Esc</kbd>
          </div>
          <ul className='tsk-palette__list'>
            {items.length === 0 && <li className='tsk-palette__empty'>{t('ui.pal.empty')}</li>}
            {items.map((item, i) => (
              <li
                key={item.id}
                className={`tsk-palette__item${i === cursor ? ' is-active' : ''}`}
                onMouseEnter={() => this.setState({ cursor: i })}
                onClick={() => this.choose(item)}
              >
                <span className='tsk-palette__icon'><FontAwesomeIcon icon={['fas', item.icon]} /></span>
                <span className='tsk-palette__label'>{item.label}</span>
                <span className='tsk-palette__hint'>{item.hint}</span>
              </li>
            ))}
          </ul>
          <div className='tsk-palette__footer'>
            <span><kbd>↑</kbd><kbd>↓</kbd> {t('ui.pal.navigate')}</span>
            <span><kbd>↵</kbd> {t('ui.pal.open')}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(CommandPalette);
